/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListOf1OfRoleDto } from '../models/ListOf1OfRoleDto';
import type { PostPutRoleRequestAdmin } from '../models/PostPutRoleRequestAdmin';
import type { RoleDto } from '../models/RoleDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RolesService {
    /**
     * **Required Policy:** `ViewRoles`
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static getRoleAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<RoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageRoles`
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static putRoleAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutRoleRequestAdmin,
    }): CancelablePromise<RoleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/roles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteRoles`
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static deleteRoleAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<RoleDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewRoles`
     * @returns ListOf1OfRoleDto OK
     * @throws ApiError
     */
    public static getRolesAdmin({
        id,
        searchWord,
        createdAtFrom,
        createdAtTo,
    }: {
        id?: number,
        searchWord?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
    }): CancelablePromise<ListOf1OfRoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/roles',
            query: {
                'id': id,
                'searchWord': searchWord,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageRoles`
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static postRoleAdmin({
        requestBody,
    }: {
        requestBody?: PostPutRoleRequestAdmin,
    }): CancelablePromise<RoleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/roles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
